import React, { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";

const BannerFive = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!showModal) return;

    const existingScript = document.querySelector("script[data-hs-meetings]");

    if (!existingScript) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.setAttribute("data-hs-meetings", "true");
      s.onload = () => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      };
      document.body.appendChild(s);
    } else {
      setTimeout(() => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      }, 100);
    }
  }, [showModal]);

  const handleOpenModal = (e) => {
    e.preventDefault();
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      {/* ================== BannerFive Start ==================*/}
      <div
        className="banner-area bg-relative banner-area-2 pb-0 bg-cover"
        style={{ backgroundImage: 'url("./assets/img/banner-5/5.png")' }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 pb-xl-5 align-self-center">
              <div className="banner-inner pe-xl-4 pb-5">
                <span
                  className="bg-base-2 text-white subtitle"
                  data-aos="fade-right"
                  data-aos-delay="100"
                  data-aos-duration="1500"
                >
                  Kickstart Your Startup — The Right Way
                </span>
                <h1
                  className="title text-white"
                  data-aos="fade-right"
                  data-aos-delay="250"
                  data-aos-duration="1500"
                >
                  From seed to scale. Investing in Innovative Solutions
                </h1>
                <p
                  className="content pe-xl-4 "
                  data-aos="fade-right"
                  data-aos-delay="350"
                  data-aos-duration="1500"
                  style={{
                    fontSize: "clamp(0.95rem, 2.5vw, 1.15rem)",
                    fontWeight: "500",
                    color: "#ffffff",
                    opacity: 1,
                    letterSpacing: "0.3px"
                  }}
                >
                 We help founders develop, accelerate, and fund investor-ready businesses through structured clarity, accelerated execution, and capital alignment.
                </p>
                <button
                  className="btn btn-border-base-2"
                  data-aos="fade-right"
                  data-aos-delay="450"
                  data-aos-duration="1500"
                  onClick={handleOpenModal}
                  style={{ cursor: 'pointer' }}
                >
                 Book a Strategy Call <FaArrowRight />
                </button>
              </div>
            </div>
            <div className="col-lg-6 col-md-9 align-self-end">
              <div className="banner-thumb-2 mt-4 mt-lg-0">
                <div className="main-img-wrap">
                  <img
                    className="banner-animate-img banner-animate-img-1 left_image_bounce"
                    src="assets/img/banner-5/4.png"
                    alt="Startup funding illustration - left element"
                  />
                  <img
                    className="banner-animate-img banner-animate-img-3 top_image_bounce"
                    src="assets/img/banner-5/3.png"
                    alt="Innovation and technology graphic"
                  />
                  <div>
                    <img
                      className="main-img"
                      src="https://agiletechwp.wowtheme7.com/wp-content/uploads/2023/03/1-9.png"
                      alt="Startup founder working on innovative solution"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* HubSpot Modal */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            overflow: 'auto'
          }}
          onClick={handleCloseModal}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              maxWidth: '800px',
              width: '100%',
              maxHeight: '90vh',
              overflow: 'auto',
              position: 'relative',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
              margin: '0 auto'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseModal}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: '#50af9b',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '35px',
                height: '35px',
                fontSize: '20px',
                cursor: 'pointer',
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                lineHeight: 1
              }}
              aria-label="Close modal"
            >
              ×
            </button>
            <div style={{ padding: '20px' }}>
              <h3 style={{ 
                marginBottom: '20px', 
                color: '#333', 
                textAlign: 'center',
                fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                paddingRight: '40px'
              }}>
                Book Your Meeting
              </h3>
              <div
                className="meetings-iframe-container"
                data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                style={{ minHeight: 'clamp(450px, 80vh, 600px)' }}
              ></div>
            </div>
          </div>
        </div>
      )}

      {/* ================== BannerFive End ==================*/}
    </>
  );
};

export default BannerFive;
